const types = {
  CLEAR_CURRENT: 'INITIATIVE_ASSISTANTS_CLEAR_CURRENT',
  GET_REQUEST: 'INITIATIVE_ASSISTANTS_GET_REQUEST',
  GET_SUCCESS: 'INITIATIVE_ASSISTANTS_GET_SUCCESS',
  GET_FAILURE: 'INITIATIVE_ASSISTANTS_GET_FAILURE',

  SAVE_REQUEST: 'INITIATIVE_ASSISTANTS_SAVER_REQUEST',
  SAVE_SUCCESS: 'INITIATIVE_ASSISTANTS_SAVE_SUCCESS',
  SAVE_FAILURE: 'INITIATIVE_ASSISTANTS_SAVE_FAILURE',

  GETALL_REQUEST: 'INITIATIVE_ASSISTANTS_GETALL_REQUEST',
  GETALL_SUCCESS: 'INITIATIVE_ASSISTANTS_GETALL_SUCCESS',
  GETALL_FAILURE: 'INITIATIVE_ASSISTANTS_GETALL_FAILURE',

  DELETE_REQUEST: 'INITIATIVE_ASSISTANTS_DELETE_REQUEST',
  DELETE_SUCCESS: 'INITIATIVE_ASSISTANTS_DELETE_SUCCESS',
  DELETE_FAILURE: 'INITIATIVE_ASSISTANTS_DELETE_FAILURE',    

  UPDATE_REQUEST: 'INITIATIVE_ASSISTANTS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'INITIATIVE_ASSISTANTS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'INITIATIVE_ASSISTANTS_UPDATE_FAILURE'    

};

export default types;